import {connect} from 'react-redux'
import CategoriesView from '../components/CategoriesView'
import {changeStep} from '../../../layouts/Content/modules/step'
import {setLoadingContent} from '../../../layouts/Content/modules/loadingContent'
import {loadCategories, selectCategory} from '../modules/categories'
import {STEPS} from '../../../constants'
import {applicationLaunch} from "../../../store/application";
import {loadSingleProducts} from "../../Products/modules/products";


const mapDispatchToProps = {
  setLoadingContent: setLoadingContent,
  loadCategories: loadCategories,
  loadSingleProducts: loadSingleProducts,
  next: (category_id) => dispatch => {
    if (category_id) {
      dispatch(selectCategory(category_id));
    }
    dispatch(changeStep(STEPS.PRODUCTS));
  },
  launchApplication: (app_guid, product_id) => (dispatch, getStore) => {
    const locale = getStore().i18n.locale;
    dispatch(applicationLaunch(app_guid, product_id, locale))
  },
};

const mapStateToProps = (state) => ({
  categories: state.categories.list,
  selectedCategory: state.categories.selectedCategory,
  singleProducts: state.products.singleProducts
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesView)


// WEBPACK FOOTER //
// ./src/components/Categories/containers/CategoriesContainer.js